import { Nav, NavDropdown, Navbar } from "react-bootstrap";
import DefaultUser from "./../../assets/images/default-user.png";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfileRequest } from "./../../services/authService";
import { updateUserProfile } from "../../store/actions/auth";

const Header = () => {
  const [arrowDown, setArrowDown] = useState(true);
  const { nickname, avatar } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const init = useCallback(async () => {
    const profile = await getProfileRequest();
    dispatch(updateUserProfile(profile));
  }, [dispatch]);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <div className="main-header d-flex w-100 px-xl-5 px-3 pt-4 justify-content-between">
      <div>
        <p className="h2 fw-bolder mb-0 text-primary text-capitalize">
          Hello, {nickname}!
        </p>
        <p className="text-primary my-2">What would you like to focus on today?</p>
      </div>

      <Navbar className="p-0 d-flex align-items-baseline">
        <Nav className="me-0">
          <NavDropdown
            onToggle={() => setArrowDown(!arrowDown)}
            className="d-flex py-0 px-0 custom-dropdown-toggle"
            dir=""
            align="end"
            title={
              <div className="d-flex align-items-center px-0">
                <img
                  src={avatar || DefaultUser}
                  alt="Avatar"
                  width={40}
                  height={40}
                  className="rounded-circle"
                />  
              </div>
            }
          >
            <NavDropdown.Item href="/logout">Log Out</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar>
    </div>
  );
};

export default Header;
